import React from 'react';
import AppleStoreButtonRender from './AppleStoreButtonRender';

export const AppleStoreButton =():JSX.Element=>{
	return <AppleStoreButtonRender/>;
};